import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';

import connectionApplicationKeys from '@/api/queries/connectionApplication/keyFactory';
import { PatchCommissioningDataInput } from '@/gql/graphql';

const PatchCommissioningData = graphql(`
  mutation PatchCommissioningData($input: PatchCommissioningDataInput!) {
    patchCommissioningData(input: $input)
  }
`);

const usePatchCommissioningData = (
  options?: UseMutationOptions<
    PatchCommissioningDataInput,
    unknown,
    PatchCommissioningDataInput
  >
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (input) => {
      await gqlClient.request(PatchCommissioningData, {
        input,
      });

      return input;
    },
    onSuccess: (mutationInput) => {
      void queryClient.invalidateQueries({
        queryKey: connectionApplicationKeys.connectionApplication(
          mutationInput.connectionApplicationPublicId
        ),
      });
    },
    ...options,
  });
};

export default usePatchCommissioningData;
